import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { formatApiError } from "../lib/api";
import { motion } from "framer-motion";
import logo from "../assets/logo.png";

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role) return <Navigate to="/onboarding" replace />;

  async function submit(e) {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(email, password, name);
      navigate("/onboarding");
    } catch (e) { setErr(formatApiError(e)); }
    finally { setLoading(false); }
  }

  return (
    <div className="relative min-h-screen flex items-center justify-center px-6">
      <div className="bps-ambient" />
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src={logo}
            alt="Back Pain Solution"
            data-testid="bps-logo"
            className="mx-auto w-36 sm:w-44 h-auto mb-2 drop-shadow-[0_0_24px_rgba(34,211,238,0.35)] select-none"
            draggable={false}
          />
          <div className="bps-eyebrow">Back Pain Solution</div>
          <h1 className="font-display text-4xl sm:text-5xl font-light tracking-tighter mt-3 text-white">
            Begin your reset.
          </h1>
          <p className="text-sm text-[#9AAEC6] mt-4">A 4-week mind–body program guided just for you.</p>
        </div>

        <form onSubmit={submit} className="space-y-4 bps-card p-6" data-testid="register-form">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#7C8FA8]">Full name</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name" className="w-full bg-white/5 rounded-2xl px-4 py-4 mt-1 outline-none focus:ring-2 focus:ring-[#22D3EE]" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#7C8FA8]">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" data-testid="register-email" className="w-full bg-white/5 rounded-2xl px-4 py-4 mt-1 outline-none focus:ring-2 focus:ring-[#22D3EE]" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#7C8FA8]">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={6} required autoComplete="new-password" data-testid="register-password" className="w-full bg-white/5 rounded-2xl px-4 py-4 mt-1 outline-none focus:ring-2 focus:ring-[#22D3EE]" />
          </div>
          {err && <div className="text-sm text-[#F87171]" data-testid="register-error">{err}</div>}
          <button disabled={loading} data-testid="register-submit" className="w-full py-4 rounded-full bg-[#22D3EE] text-[#03101F] font-medium disabled:opacity-30 transition-all hover:-translate-y-0.5">
            {loading ? "Creating…" : "Create account"}
          </button>
        </form>

        <p className="text-center text-sm text-[#9AAEC6] mt-6">
          Already registered?{" "}
          <Link to="/login" className="text-[#22D3EE] font-medium" data-testid="goto-login">Sign in</Link>
        </p>
      </motion.div>
    </div>
  );
}
